import { render, staticRenderFns } from "./EmfFlowUpDataRecordModal.vue?vue&type=template&id=1fa53a17&scoped=true"
import script from "./EmfFlowUpDataRecordModal.vue?vue&type=script&lang=js"
export * from "./EmfFlowUpDataRecordModal.vue?vue&type=script&lang=js"
import style0 from "./EmfFlowUpDataRecordModal.vue?vue&type=style&index=0&id=1fa53a17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa53a17",
  null
  
)

export default component.exports